import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const SimpleDialog = ({ isOpen, onClose, message, showCloseButton = false }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 500); // Match this with the CSS transition time
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  return (
    <div className={`simple-dialog-overlay ${isOpen ? 'active' : ''}`}>
      <div className={`simple-dialog-container ${isVisible ? 'visible' : ''} ${isOpen ? 'slide-in' : 'slide-out'}`}>
        <div className="simple-dialog blue-theme">
          <div className="simple-dialog-content">
            <p>{message}</p>
          </div>
          {showCloseButton && (
            <button className="close-button" onClick={onClose}>
              <X size={24} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimpleDialog;